// KeyRef.ts
// Utility type for referencing keys in other models or enums.
// Used for type-safe references across the codebase.

/**
 * Utility type for referencing keys in other models or enums.
 * Used for type-safe references across the codebase.
 */
export type KeyRef =
    | string
    | {
    type: string
    key: string
}

export function getKey(ref: KeyRef): string {
    if (typeof ref === 'string') {
        return getKeyFromString(ref)
    }
    return ref.key
}

export function getKeyFromString(ref: string): string {
    return ref.split("###", 2)[1] ?? ref
}